import script from "./videos.vue?vue&type=script&setup=true&lang=ts"
export * from "./videos.vue?vue&type=script&setup=true&lang=ts"

import "./videos.vue?vue&type=style&index=0&id=714d41ee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-714d41ee"]])

export default __exports__